var DateValidation = /** @class */ (function () {
    function DateValidation() {
    }
    DateValidation.prototype.validate = function (parameters, value, obj) {
        var minNow = parameters.MinDateGreaterThanNow;
        var maxNow = parameters.MinDateGreaterThanNow;
        var minDate = parameters.MinDateTime;
        var maxDate = parameters.MaxDateTime;
        var onlyWhenIdZero = parameters.OnlyWhenIdZero;
        if (onlyWhenIdZero && obj.id > 0) {
            return true;
        }
        var nowComplete = new Date();
        var now = nowComplete.setHours(nowComplete.getHours(), nowComplete.getMinutes(), 0, 0);
        var maxComplete = new Date(maxDate);
        var max = maxComplete.setHours(maxComplete.getHours(), maxComplete.getMinutes(), 0, 0);
        var minComplete = new Date(minDate);
        var min = minComplete.setHours(minComplete.getHours(), minComplete.getMinutes(), 0, 0);
        var valueDateComplete = new Date(value);
        var valueDate = valueDateComplete.setHours(valueDateComplete.getHours(), valueDateComplete.getMinutes(), 0, 0);
        if (minNow && maxDate && now < max) {
            return valueDate > now && valueDate < max;
        }
        if (maxNow && maxNow && (min < now)) {
            return valueDate > min && value < now;
        }
        else if (minDate && maxDate) {
            return valueDate > min && valueDate < max;
        }
        else if (minDate) {
            return valueDate > min;
        }
        else if (maxDate) {
            return valueDate < max;
        }
        else {
            return true;
        }
        ;
    };
    DateValidation.prototype.canValidate = function (claims) {
        return true;
    };
    return DateValidation;
}());
export { DateValidation };
